import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "./Reveal";

export const PlaceholderBlock = ({ topic, testid }) => (
  <p
    data-testid={testid}
    className="text-sm md:text-base text-[#71717A] italic leading-relaxed border border-dashed border-white/15 rounded-lg px-5 py-4"
  >
    Editable placeholder — {topic} will be written here.
  </p>
);

export const CaseStudyLayout = ({ number, category, title, headline, intro, sections, testid }) => (
  <div data-testid={testid} className="bg-[#080808] text-[#F9F9F9] min-h-screen pt-28 md:pt-36 pb-24">
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <Reveal>
        <Link
          data-testid="case-study-back-link"
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#71717A] hover:text-[#0EA5E9] transition-colors"
        >
          <ArrowLeft size={14} /> Back to portfolio
        </Link>
        <p className="font-mono-alt text-xs text-[#71717A] mt-12">CASE STUDY {number}</p>
        <p className="text-xs uppercase tracking-[0.25em] text-[#0EA5E9] font-mono-alt mt-3">{category}</p>
        <h1 className="font-heading text-4xl md:text-6xl tracking-tighter leading-[1.05] font-medium mt-6">{title}</h1>
        <p className="font-heading text-xl md:text-2xl text-[#A1A1AA] mt-4">{headline}</p>
        {intro && <p className="text-base md:text-lg text-[#A1A1AA] leading-relaxed mt-8">{intro}</p>}
      </Reveal>

      <div className="mt-16 space-y-16">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={0.05}>
            <section data-testid={s.testid} className="border-t border-white/10 pt-8">
              <p className="font-mono-alt text-xs text-[#0EA5E9]">{String(i + 1).padStart(2, "0")}</p>
              <h2 className="font-heading text-2xl md:text-3xl tracking-tight font-medium mt-2">{s.title}</h2>
              <div className="mt-5 space-y-4">
                {s.body &&
                  s.body.map((p, j) => (
                    <p key={j} className="text-sm md:text-base text-[#A1A1AA] leading-relaxed">
                      {p}
                    </p>
                  ))}
                {s.list && (
                  <ul className="space-y-3">
                    {s.list.map((item, j) => (
                      <li key={j} className="flex items-start gap-3 text-sm text-[#A1A1AA]">
                        <span className="mt-2 h-px w-4 bg-[#0EA5E9] shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
                {s.placeholder && <PlaceholderBlock topic={s.placeholder} testid={`${s.testid}-placeholder`} />}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  </div>
);
